import { FC } from "react";
import { useTranslation } from "react-i18next";
import emptySearch from "Static/images/empty-search.png";
import { Container } from "./styles";

interface IEmptySearch {
  searchText?: string;
}

const EmptySearch: FC<IEmptySearch> = ({ searchText }) => {
  const { t } = useTranslation('editObra');

  return (
    <Container>
      <img src={emptySearch} className="imgSearch" alt="" />
      <span className="title">
        {t('disciplines.emptySearchTitle', { search: searchText })}
      </span>
      <span className="subtitle">
        {t('disciplines.emptySearchSubtitle')}
      </span>
    </Container>
  );
};

export default EmptySearch;
